/* eslint-disable no-restricted-syntax */
import queryString from 'query-string';
import qs from 'qs';
import { APP_ENDPOINT } from '../shared/Constants';

const DEFAULT_PARSE_OPTIONS = { allowDots: true, skipNulls: true, ignoreQueryPrefix: true };
const DEFAULT_STRINGIFY_OPTIONS = { allowDots: true, skipNulls: true };

/**
 * Parses the URL search params.
 */
export function parse(search, options = DEFAULT_PARSE_OPTIONS) {
  return qs.parse(search, options);
}

/**
 * Stringify object to url params.
 */
export function stringify(obj, options = DEFAULT_STRINGIFY_OPTIONS) {
  return qs.stringify(obj, options);
}

/**
 * Filters pagination params: first, lats, before, after
 */
export function filterPagination(params) {
  const page = {};
  ['first', 'last', 'before', 'after'].forEach((val) => {
    if (params[val]) {
      page[val] = params[val];
    }
  });

  return page;
}

export function filterPaginationWithSize(params, pageSize = 25) {
  const page = filterPagination(params);
  // set default page size if not present - to supply to the initial query
  // this should match
  if (!page.first) {
    if (!page.last) {
      page.first = pageSize;
    }
  }
  return page;
}

/**
 * Converts PrimeReact sortOrder field to what our API expects.
 * https://www.primefaces.org/primereact/#/datatable
 */
export function toSortDir(sortOrder) {
  if (sortOrder === -1) {
    return 'DESC';
  }
  return 'ASC';
}

/**
 * Converts our sortDir to the sortOrder for PrimeReact.
 */
export function toSortOrder(sortOrder) {
  if (sortOrder === 'DESC') {
    return -1;
  }
  return 1;
}

export const sortUrl = (source, location, history) => {
  const sortBy = source.sortField;
  const sortDir = toSortDir(source.sortOrder);

  const sort = {
    sortBy,
    sortDir,
  };

  const params = parse(location.search);

  const newSort = {
    ...params.sort,
    ...sort,
  };

  const search = stringify({
    ...params,
    sort: newSort,
  });

  // update url with the new search, keep the rest of the values
  history.push({
    ...location,
    search,
  });
};

export const sortHelper = {
  toSortDir,
  toSortOrder,
};

export function emptyConnection() {
  return {
    edges: [],
    totalCount: 0,
    indexFrom: 0,
    indexTo: 0,
    pageInfo: {
      hasNextPage: false,
      hasPreviousPage: false,
    },
  };
}

// DEPRECATED BELLOW THIS LINE

export const objectToQueryParams = (queryObject, ex = []) => {
  const clonedQueryObject = Object.assign({}, queryObject);
  if (ex && ex.length > 0) {
    ex.map(el => delete clonedQueryObject[el]);
  }

  for (const prop in clonedQueryObject) {
    if (!{}.hasOwnProperty.call(clonedQueryObject, prop)) {
      delete clonedQueryObject[prop];
    }
  }
  return queryString.stringify(clonedQueryObject);
};

// eslint-disable-next-line max-len
export const regenerateUrlWithQuery = (oldUrl, queryObject, ex = []) => `${oldUrl}?${objectToQueryParams(queryObject, ex)}`;

export const getObjectFromQueryParam = queryParams => queryString.parse(queryParams);

// eslint-disable-next-line max-len
export const buildSchedulingRedirectUrl = id => `${window.location.origin}${APP_ENDPOINT.SCHEDULING}#/accounts/${id}/dashboard`;

export const buildAdminRedirectUrl = id => `${window.location.origin}${APP_ENDPOINT.ADMIN}#/accounts/${id}/dashboard`;

export const buildCreditRedirectUrl = id => `${window.location.origin}${APP_ENDPOINT.CREDIT}#/${id}/cr/dashboard`;

export const updateUrl = (params, history) => {
  const oldPath = history.location;
  const newPath = regenerateUrlWithQuery(oldPath.pathname, params);
  history.push(newPath);
};
